import type { TableSemanticSchema } from './types';

export const AssumptionSchema: TableSemanticSchema = {
  id: 'assumption',
  name: 'Assumption Map',
  description:
    'Certainty vs. impact 2×2 for de-risking. High-impact, low-certainty assumptions are the ones you test first.',
  cells: [
    { id: 'leap_of_faith', label: 'Leap of Faith — High Impact, Low Certainty', row: 0, col: 0, accent: '#dc2626' },
    { id: 'test_next', label: 'Test Next — High Impact, High Certainty', row: 0, col: 1, accent: '#f59e0b' },
    { id: 'low_priority', label: 'Low Priority — Low Impact, Low Certainty', row: 1, col: 0, accent: '#64748b' },
    { id: 'safe', label: 'Safe — Low Impact, High Certainty', row: 1, col: 1, accent: '#16a34a' },
  ],
  itemFields: [
    { key: 'certainty', label: 'Certainty', kind: 'enum', required: true,
      options: [
        { value: 'high', label: 'High' },
        { value: 'low', label: 'Low' },
      ] },
    { key: 'impact', label: 'Impact', kind: 'enum', required: true,
      options: [
        { value: 'high', label: 'High' },
        { value: 'low', label: 'Low' },
      ] },
    { key: 'testPlan', label: 'Test Plan', kind: 'string' },
    { key: 'evidence', label: 'Evidence', kind: 'string' },
    { key: 'status', label: 'Status', kind: 'enum',
      options: [
        { value: 'untested', label: 'Untested' },
        { value: 'testing', label: 'Testing' },
        { value: 'confirmed', label: 'Confirmed' },
        { value: 'refuted', label: 'Refuted' },
      ] },
  ],
  renderingHints: { layout: 'quadrant' },
};
